import React from "react";
import {connect} from 'react-redux';
import {initializationBasic, saveBasic} from "@componentDP/js_react/redux/actions/profile_basic";
import {bindActionCreators} from "redux";
import LoadingBasic from "../skeletons/loading_basic";
import BasicForm from "./basic_form";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import { withTranslation } from 'react-i18next';

class Basic extends React.Component {
    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
        const {initializationBasic} = this.props;
        initializationBasic();
    }
    save(data, successCallback) {
        const {saveBasic, t} = this.props;
        saveBasic(data, successCallback, t);
    }
    render() {
        const {save} = this;
        const { t } = this.props;
        const {
            profileBasic,
            loadingProfileBasic,
            loadedProfileBasic,
            mailingRegion,
            mailingTownType,
            digitalProfileSettings,
        } = this.props;
        return (
            <Grid container spacing={2} className="basic">
                <Grid item xs={12}>
                    <Typography variant="h6" align={"left"}>
                        {t('general')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {loadingProfileBasic || !loadedProfileBasic
                        ? <LoadingBasic />
                        : <BasicForm
                            profileBasic={profileBasic}
                            mailingRegion={mailingRegion}
                            mailingTownType={mailingTownType}
                            digitalProfileSettings={digitalProfileSettings}
                            onSave={save} />}
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    const {
        profileBasic,
        loadingProfileBasic,
        loadedProfileBasic,
        mailingRegion,
        mailingTownType,
        digitalProfileSettings,
    } = state;
    return {
        profileBasic,
        loadingProfileBasic,
        loadedProfileBasic,
        mailingRegion,
        mailingTownType,
        digitalProfileSettings,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        initializationBasic,
        saveBasic,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Basic));
